import styled from 'styled-components'
import { t } from 'ttag'
import { useState, useContext, useCallback } from 'react'

import { errors } from '@h2/api'
import { Globals } from '@h2/globals'
import { Modal } from '@h2/components/containers/modal'
import { Alert } from '@h2/components/display/alert'
import { Heading } from '@h2/components/typography/heading'
import { Text } from '@h2/components/typography/text'
import { Button } from '@h2/components/buttons/button'
import { GraduationYear } from '@h2/features/personalProfile/components/edit/graduationYear'

const InfoHeading = styled(Heading)`
  display: flex;
  align-items: center;
`
const GraduationYearFormModal = ({isOpen, setIsOpen}) => {
    const { userProfile } = useContext(Globals)
    const [error, setError] = useState(null)
    const onError = useCallback(err => {
      setError(errors.getMessage(err))
    }, [])
    const onSuccess = useCallback(() => {
      setError(null)
      setIsOpen(false)
    }, [setIsOpen])

    return (
      <Modal isOpen={isOpen} onClose={() => setIsOpen(false)}>
        <Modal.Header>
          <InfoHeading level="2">
            {t`Graduation Year Required`}
          </InfoHeading>
        </Modal.Header>
        <Modal.Body>
          {error && (
            <Alert
              type="error"
              margin="0 0 20px 0"
              message={error}
              onClose={() => setError(null)}
            />
          )}
          <Text color="#0F1820">
            {t`Select your high-school graduation year to access lessons`}
          </Text>
          <GraduationYear user={userProfile} onError={onError} onSuccess={onSuccess}>
            <Button
              onClick={() => setIsOpen(false)}
              type="button"
              size="large"
              variant="outlined">
              {t`Cancel`}
            </Button>
          </GraduationYear>
        </Modal.Body>
      </Modal>
    )
}

export { GraduationYearFormModal }
